import React, {useState} from 'react';
import PropTypes from 'prop-types';
import "./_style.scss";
import { IconDropdownModel } from "./_model";
import { imageCdnUrls } from "../ImageCdnUrls";
import { getFullWidthOfDropdown } from "../../../helpers/domHelpers";
import { useOnClickOutside } from "../../../helpers/hooks/useOnClickOutside";

export default function IconDropdown(props) {
	const {menuOptions, selectedOption, onChange, className = ""} = props;

	const [activeOption, setActiveOption] = useState(selectedOption);
	const [isOpen, setIsOpen] = useState(false);
	const ref = useOnClickOutside(() => setIsOpen(false));

	const [options, setOptions] = useState(menuOptions);

	const selectOption = option => {
		setIsOpen(!isOpen);
		setActiveOption(option);
		const newOption = options.map(o => {
			return {
				...o,
				isSelected: o.id === option.id,
				isHovered: false
			};
		});
		setOptions(newOption);
		if (onChange === undefined) return;
		onChange(option);
	};

	const hoverOption = (optionId) => {
		const newOptions = options.map(o => {
			return {
				...o,
				isHovered: o.id === optionId
			};
		});
		setOptions(newOptions);
	};

	const renderOptions = () => isOpen &&
		<div className="icon-dropdown-option-list">
			{options.map(option => (
				<div
					className={`icon-dropdown-option-item ${option.isSelected ? "option-selected" : ''}`}
					key={option.id}
					onClick={() => selectOption(option)}
					onMouseEnter={() => hoverOption(option.id)}
					onMouseLeave={() => hoverOption(-1)}
				>
				{!!option.icon && <img
					className="icon-dropdown-option-icon"
					src={(option.isHovered ? option.hoverIcon : option.icon)}
					alt={option.name}
				/>}
					<p className={`icon-dropdown-option-name ${!option.icon ? "no-icon" : ''}`}>{option.name}</p>
				</div>
			))}
		</div>;


	const width = getFullWidthOfDropdown(menuOptions);

	return (
		<div
			className={`dropdown icon-dropdown-style ${className} ${isOpen ? "open" : ""}`}
			onClick={() => setIsOpen(!isOpen)}
			style={{ width }}
			ref={ref}
		>
			<div className="icon-dropdown-selected">
				{!!activeOption.icon && <img
					className="icon-dropdown-option-icon"
					src={activeOption.icon}
					alt={activeOption.name}
				/>}
				<p>{activeOption.name}</p>
			</div>
			{renderOptions()}
			<span className="icon-dropdown-arrow">
				<img src={imageCdnUrls.caret_down_grey} alt="down" />
			</span>
		</div>);
}

IconDropdown.propTypes = {
	menuOptions: PropTypes.arrayOf(PropTypes.shape(IconDropdownModel)),
	selectedOption: PropTypes.shape(IconDropdownModel),
	onChange: PropTypes.func,
	className: PropTypes.string
};
